import { toast, ToastOptions, Id } from 'react-toastify';

const defaultConfig: ToastOptions = {
  position: 'top-center',
  autoClose: 3000,
  // hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'light',
};

export const showSuccessToast = (message: string, options?: ToastOptions): Id => {
  return toast.success(message, {
    ...defaultConfig,
    toastId: message,
    ...options,
  });
};

export const showErrorToast = (message: string, options?: ToastOptions): Id => {
  return toast.error(message, {
    ...defaultConfig,
    toastId: message,
    ...options,
  });
};

export const showInfoToast = (message: string, options?: ToastOptions): Id => {
  return toast.info(message, {
    ...defaultConfig,
    toastId: message,
    ...options,
  });
};

export const showWarningToast = (message: string, options?: ToastOptions): Id => {
  return toast.warning(message, {
    ...defaultConfig,
    toastId: message,
    ...options,
  });
};

export const showPromiseToast = <T,>(
  promise: Promise<T>,
  messages: {
    pending: string;
    success: string;
    error: string;
  },
  options?: ToastOptions
) => {
  return toast.promise(
    promise,
    {
      pending: messages.pending,
      success: messages.success,
      error: messages.error,
    },
    {
      ...defaultConfig,
      ...options,
    }
  );
};

export const clearAllToasts = (): void => {
  toast.dismiss();
};

export const clearToast = (toastId: Id): void => {
  toast.dismiss(toastId);
};

export const updateToast = (
  toastId: Id,
  options: ToastOptions & { render?: string }
): void => {
  toast.update(toastId, options);
};

export const showCustomToast = (content: React.ReactNode, options?: ToastOptions): Id => {
  return toast(content, {
    ...defaultConfig,
    ...options,
  });
};

export default {
  success: showSuccessToast,
  error: showErrorToast,
  info: showInfoToast,
  warning: showWarningToast,
  promise: showPromiseToast,
  clear: clearToast,
  clearAll: clearAllToasts,
  update: updateToast,
  custom: showCustomToast,
};
